import React, { useState } from 'react';
import { motion } from 'framer-motion';
import pedro from './assets/image.png';
import background from './assets/background.avif';
import { 
  Linkedin, 
  Mail, 
  Video, 
  Music, 
  Palette, 
  Globe, 
  Zap,
  ArrowRight
} from 'lucide-react';
import './App.css';
import ColorGrading from './ColorGrading';

// SVGs das logos
const logos = [
  {
    name: 'Premiere',
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="12" fill="#2D2D2D"/><text x="50%" y="60%" textAnchor="middle" fill="#EED475" fontSize="20" fontWeight="bold" fontFamily="Arial">Pr</text></svg>
    )
  },
  {
    name: 'After Effects',
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="12" fill="#2D2D2D"/><text x="50%" y="60%" textAnchor="middle" fill="#00FFFF" fontSize="20" fontWeight="bold" fontFamily="Arial">Ae</text></svg>
    )
  },
  {
    name: 'DaVinci Resolve',
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="24" fill="#222"/><circle cx="24" cy="24" r="18" fill="#222" stroke="#F9C642" strokeWidth="2"/><circle cx="24" cy="17" r="6" fill="#3ED6FF"/><circle cx="17.5" cy="31" r="6" fill="#F9C642"/><circle cx="30.5" cy="31" r="6" fill="#FF5C5C"/></svg>
    )
  },
  {
    name: 'CapCut',
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="12" fill="#fff"/><rect x="10" y="14" width="28" height="4" rx="2" fill="#000"/><rect x="10" y="30" width="28" height="4" rx="2" fill="#000"/><path d="M12 16L36 32" stroke="#000" strokeWidth="3" strokeLinecap="round"/><path d="M36 16L12 32" stroke="#000" strokeWidth="3" strokeLinecap="round"/></svg>
    )
  },
];

function InfiniteSlider() {
  // Repete as logos para efeito infinito
  const repeated = [...logos, ...logos, ...logos];
  return (
    <div className="slider-wrapper">
      <div className="slider-track">
        {repeated.map((logo, idx) => (
          <div className="slider-logo" key={idx} title={logo.name}>
            {logo.svg}
          </div>
        ))}
      </div>
    </div>
  );
}

// Remover a definição do componente BeforeAfterSlider

const behanceProjects = [
  {
    title: "Detonautas - WallyRec",
    url: "https://www.behance.net/gallery/225778845/Detonautas-WallyRec",
    thumbnail: "/thumbnails/detonautas-wallyrec.jpg"
  },
  {
    title: "CaraPreta - WallyRec",
    url: "https://www.behance.net/gallery/225778845/CaraPreta-WallyRec",
    thumbnail: "/thumbnails/carapreta-wallyrec.jpg"
  },
  {
    title: "Estádio MRV - TyroneFPV",
    url: "https://www.behance.net/gallery/225778845/Estadio-MRV-TyroneFPV",
    thumbnail: "/thumbnails/estadio-mrv.jpg"
  },
  {
    title: "Brainstorm.Academy",
    url: "https://www.behance.net/gallery/225778845/BrainstormAcademy",
    thumbnail: "/thumbnails/brainstorm-academy.jpg"
  },
  {
    title: "Reels - Carlinhos Brown (Arrastão)",
    url: "https://www.behance.net/gallery/221190685/Reels-Carlinhos-Brown-(Arrastao)",
    thumbnail: "/thumbnails/carlinhos-brown-arrastao.jpg"
  },
  {
    title: "Reels - Carlinhos Brown",
    url: "https://www.behance.net/gallery/221097249/Reels-Carlinhos-Brown",
    thumbnail: "/thumbnails/carlinhos-brown.jpg"
  },
  {
    title: "Reels - Videos MicroDrone",
    url: "https://www.behance.net/gallery/225778845/Reels-Videos-MicroDrone",
    thumbnail: "/thumbnails/microdrone.jpg"
  },
  {
    title: "Animação de Logotipo: OPEU",
    url: "https://www.behance.net/gallery/218476289/Animacao-de-Logotipo-OPEU",
    thumbnail: "/thumbnails/opeu.jpg"
  },
  {
    title: "Motion Design - TRE-BA",
    url: "https://www.behance.net/gallery/225778845/Motion-Design-TRE-BA",
    thumbnail: "/thumbnails/treba.jpg"
  },
  {
    title: "Animação de Logotipo: TRE-BA",
    url: "https://www.behance.net/gallery/225778845/Animacao-de-Logotipo-TRE-BA",
    thumbnail: "/thumbnails/animacao-treba.jpg"
  },
  {
    title: "VFX - Diversos",
    url: "https://www.behance.net/gallery/211071001/VFX-Diversos",
    thumbnail: "/thumbnails/vfx-diversos.jpg"
  },
  {
    title: "Color Grading - Diversos",
    url: "https://www.behance.net/gallery/225778845/Color-Grading-Diversos",
    thumbnail: "/thumbnails/color-grading-diversos.jpg"
  },
  {
    title: "Edição de Vídeo - Comerciais",
    url: "https://www.behance.net/gallery/225778845/Edicao-de-Video-Comerciais",
    thumbnail: "/thumbnails/edicao-comerciais.jpg"
  },
  {
    title: "Sound Design - Trilhas Sonoras",
    url: "https://www.behance.net/gallery/225778845/Sound-Design-Trilhas-Sonoras",
    thumbnail: "/thumbnails/sound-design.jpg"
  },
  {
    title: "Motion Graphics - Institucionais",
    url: "https://www.behance.net/gallery/225778845/Motion-Graphics-Institucionais",
    thumbnail: "/thumbnails/motion-graphics.jpg"
  },
  {
    title: "Produção Musical - Álbuns",
    url: "https://www.behance.net/gallery/225778845/Producao-Musical-Albuns",
    thumbnail: "/thumbnails/producao-musical.jpg"
  },
  {
    title: "Vídeos Institucionais",
    url: "https://www.behance.net/gallery/225778845/Videos-Institucionais",
    thumbnail: "/thumbnails/videos-institucionais.jpg"
  },
  {
    title: "Documentários",
    url: "https://www.behance.net/gallery/225778845/Documentarios",
    thumbnail: "/thumbnails/documentarios.jpg"
  },
  {
    title: "Vídeos de Eventos",
    url: "https://www.behance.net/gallery/225778845/Videos-de-Eventos",
    thumbnail: "/thumbnails/videos-eventos.jpg"
  },
  {
    title: "Conteúdo Digital",
    url: "https://www.behance.net/gallery/225778845/Conteudo-Digital",
    thumbnail: "/thumbnails/conteudo-digital.jpg"
  }
];



function BehanceSlider() {
  const [current, setCurrent] = useState(0);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeError, setIframeError] = useState(false);
  
  const next = () => {
    setCurrent((c) => (c + 1) % behanceProjects.length);
    setIframeLoaded(false);
    setIframeError(false);
  };
  
  const prev = () => {
    setCurrent((c) => (c - 1 + behanceProjects.length) % behanceProjects.length);
    setIframeLoaded(false);
    setIframeError(false);
  };

  // Extrai o ID do projeto da URL
  const getProjectId = (url) => url.split('/')[4];
  const project = behanceProjects[current];
  const projectId = getProjectId(project.url);

  const handleIframeLoad = () => {
    setIframeLoaded(true);
    setIframeError(false);
  };

  const handleIframeError = () => {
    setIframeLoaded(false);
    setIframeError(true);
  };

  // Timeout para forçar fallback se iframe não carregar
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!iframeLoaded && !iframeError) {
        setIframeError(true);
      }
    }, 5000); // 5 segundos de timeout

    return () => clearTimeout(timer);
  }, [current, iframeLoaded, iframeError]);

  // Sempre tentar carregar o iframe primeiro
  const shouldShowIframe = !iframeError;

  return (
    <div className="behance-slider">
      <button className="slider-btn" onClick={prev} aria-label="Anterior">&#60;</button>
      <div className="slider-project" style={{width: '100%', maxWidth: 500}}>
        {shouldShowIframe ? (
          <iframe
            src={`https://www.behance.net/embed/project/${projectId}?ilo0=1`}
            width="100%"
            height="400"
            style={{ 
              border: 'none', 
              borderRadius: '16px', 
              background: '#1a1a1a', 
              minHeight: 300,
              opacity: iframeLoaded ? 1 : 0.7
            }}
            allowFullScreen
            loading="lazy"
            frameBorder="0"
            allow="clipboard-write"
            referrerPolicy="strict-origin-when-cross-origin"
            title={project.title}
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        ) : (
          <div className="behance-fallback">
            <div className="fallback-content">
              <div className="fallback-icon">🎬</div>
              <h3>{project.title}</h3>
              <p>Clique para ver o projeto completo no Behance</p>
              <a 
                href={project.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="fallback-btn"
              >
                Ver no Behance
              </a>
            </div>
          </div>
        )}
        
        {/* Loading overlay quando iframe está carregando */}
        {shouldShowIframe && !iframeLoaded && (
          <div className="behance-loading-overlay">
            <div className="loading-content">
              <div className="loading-spinner"></div>
              <p>Carregando projeto...</p>
            </div>
          </div>
        )}
        
        <h3 style={{marginTop: 16, textAlign: 'center', color: '#fff'}}>{project.title}</h3>
      </div>
      <button className="slider-btn" onClick={next} aria-label="Próximo">&#62;</button>
    </div>
  );
}

function App() {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  // Remover a definição do componente BeforeAfterSlider

  return (
    <div className="App">
      

      {/* Hero Section */}
      <section 
        className="hero" 
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(0, 0, 0, 0.8) 0%, rgba(26, 26, 26, 0.7) 50%, rgba(45, 45, 45, 0.6) 100%), url(${background})`
        }}
      >
        <div className="container hero-grid">
          <div className="hero-photo-wrapper">
            <img src={pedro} alt="Pedro Blohem" className="hero-photo-modern" />
          </div>
          <div className="hero-text">
            <h1 className="hero-title">
              Pedro Blohem
            </h1>
            <h2 className="hero-role">Editor de Vídeo & Produtor Musical</h2>
            <p className="hero-desc">
              Especialista em Color Grading e Sound Design. Transformo ideias em experiências audiovisuais marcantes.
            </p>
            <a href="#projetos" className="btn btn-primary hero-cta">
              Ver Portfólio
              <ArrowRight size={20} />
            </a>
          </div>
        </div>
        <div className="hero-background">
          <div className="gradient-orb"></div>
        </div>
      </section>

      {/* Sobre Section */}
      <section id="sobre" className="section">
        <div className="container">
          <motion.div 
            className="section-header"
            {...fadeInUp}
          >
            <h2>Sobre Mim</h2>
            <p className="section-subtitle">Conheça minha jornada e paixão pela tecnologia</p>
          </motion.div>
          
          <motion.div 
            className="about-content"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="about-text">
              <p>
                Publicitário como formação, sou editor de vídeos e produtor musical há mais de 10 anos. 
                Especialista em Color Grading e Sound Design, me dedico a estudar a arte de contar histórias 
                através das cores e sons.
              </p>
              <p>
                Minha paixão é transformar visões criativas em experiências audiovisuais impactantes. 
                Trabalho com uma ampla gama de projetos, desde comerciais até produções musicais, 
                sempre buscando a excelência técnica e artística.
              </p>
              <p>
                Também trabalho com Animação e VFX, complementando meus projetos com elementos visuais 
                que elevam a narrativa e criam experiências imersivas para o público.
              </p>
            </div>
            
           
          </motion.div>
        </div>
      </section>
      {/* Ferramentas que eu uso - Slider */}
      <section className="section slider-section">
        <div className="container">
          <motion.div className="section-header" {...fadeInUp}>
            <h2>Ferramentas que eu uso</h2>
          </motion.div>
          <InfiniteSlider />
          <div className="skills-grid">
              <div className="skill-card">
                <Video className="skill-icon" />
                <h3>Edição de Vídeo</h3>
                <p>Adobe Premiere Pro, DaVinci Resolve, After Effects, Final Cut Pro</p>
              </div>
              <div className="skill-card">
                <Music className="skill-icon" />
                <h3>Produção Musical</h3>
                <p>Logic Pro, Pro Tools, Ableton Live, Sound Design, Mixagem</p>
              </div>
              <div className="skill-card">
                <Palette className="skill-icon" />
                <h3>Color Grading</h3>
                <p>DaVinci Resolve, Adobe SpeedGrade, LUTs, Teoria das Cores</p>
              </div>
              <div className="skill-card">
                <Globe className="skill-icon" />
                <h3>VFX & Animação</h3>
                <p>After Effects, Cinema 4D, Blender, Motion Graphics</p>
              </div>
            </div>
        </div>
      </section>
      {/* Serviços Section */}
      <section id="servicos" className="section services-section">
        <div className="container">
          <motion.div 
            className="section-header"
            {...fadeInUp}
          >
            <h2>Como Posso Ajudar</h2>
            <p className="section-subtitle">Serviços especializados para impulsionar seu negócio</p>
          </motion.div>
          
          <motion.div 
            className="services-grid"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="service-card">
              <div className="service-icon">
                <Video />
              </div>
              <h3>Edição de Vídeo</h3>
              <p>
                Edição profissional para comerciais, filmes, vídeos institucionais e conteúdo digital. 
                Narrativa visual impactante e ritmo cinematográfico.
              </p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <Music />
              </div>
              <h3>Produção Musical</h3>
              <p>
                Composição, arranjos, mixagem e masterização. Sound design para vídeos, 
                jingles e trilhas sonoras personalizadas.
              </p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <Palette />
              </div>
              <h3>Color Grading</h3>
              <p>
                Correção e tratamento de cor profissional. Criação de looks cinematográficos 
                e harmonização visual de projetos.
              </p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <Zap />
              </div>
              <h3>VFX & Motion Graphics</h3>
              <p>
                Efeitos visuais, animações e motion graphics. Complemento visual para 
                elevar a qualidade e impacto dos projetos.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Projetos Section */}
      <section id="projetos" className="section">
        <div className="container">
          <motion.div 
            className="section-header"
            {...fadeInUp}
          >
            <h2>Projetos em Destaque</h2>
            <p className="section-subtitle">Alguns dos trabalhos que me orgulho de ter desenvolvido</p>
          </motion.div>
          <BehanceSlider />
        </div>
      </section>

      {/* Color Grading Section */}
      <section className="section color-grading-section">
        <div className="container">
          <motion.div className="section-header" {...fadeInUp}>
            <p className="section-subtitle" style={{ letterSpacing: 2, textTransform: 'uppercase', fontSize: 16 }}>Antes e Depois</p>
            <h2>Arraste o slider e compare o antes e depois do Color Grading</h2>
          </motion.div>
          
          <motion.div 
            className="color-grading-grid"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="color-grading-item">
              <h3>Comparação 1</h3>
              <ColorGrading
                before="/foto01-antes.png"
                after="/foto01-depois.png"
                beforeLabel="Original"
                afterLabel="Editada"
              />
            </div>
            
            <div className="color-grading-item">
              <h3>Comparação 2</h3>
              <ColorGrading
                before="/foto02-antes.png"
                after="/foto02-depois.png"
                beforeLabel="Original"
                afterLabel="Editada"
              />
            </div>
            
            <div className="color-grading-item">
              <h3>Comparação 3</h3>
              <ColorGrading
                before="/foto03-antes.png"
                after="/foto03-depois.png"
                beforeLabel="Original"
                afterLabel="Editada"
              />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contato Section */}
      <section id="contato" className="section contact-section">
        <div className="container">
          <motion.div 
            className="section-header"
            {...fadeInUp}
          >
            <h2>Vamos Conversar</h2>
            <p className="section-subtitle">Pronto para transformar sua ideia em realidade?</p>
          </motion.div>
          
          <motion.div 
            className="contact-content"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="contact-info">
              <h3>Entre em Contato</h3>
              <p>
                Estou sempre aberto a novos projetos criativos e desafios audiovisuais. 
                Vamos transformar sua visão em uma experiência visual e sonora impactante!
              </p>
              
              <div className="contact-methods">
                <a href="mailto:pblohem@hotmail.com" className="contact-item">
                  <Mail size={20} />
                  <span>pblohem@hotmail.com</span>
                </a>
                <a href="https://linkedin.com/in/pedro-blohem-37018531b" className="contact-item">
                  <Linkedin size={20} />
                  <span>LinkedIn</span>
                </a>
              
              </div>
            </div>
            
            <div className="contact-cta">
              <h3>Vamos Criar Juntos?</h3>
              <p>
                Agende uma conversa para discutirmos seu projeto audiovisual e como posso 
                ajudar a dar vida à sua visão criativa.
              </p>
              <a href="mailto:pblohem@hotmail.com" className="btn btn-primary">
                Agendar Conversa
                <ArrowRight size={20} />
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <p>&copy; 2024 Pedro Blohem. Todos os direitos reservados.</p>
            <h4>Desenvolvido por <a href="https://www.linkedin.com/in/ricmerces/" target="_blank" rel="noopener noreferrer" style={{color: '#00A5F7'}}>Ricardo Mercês</a></h4>
            <div className="footer-links">
              <a href="#sobre">Sobre</a>
              <a href="#servicos">Serviços</a>
              <a href="#projetos">Projetos</a>
              <a href="#contato">Contato</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;   